import { Button } from '../../../Utility/Button';
import AdminViewContent from '../../../Utility/AdminViewContent';
import { EmbeddingModel } from '../../../../Types';
import { PencilSimpleIcon, TrashIcon, CopyIcon } from '@phosphor-icons/react';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { embeddingModelService } from '../../../../Services/embeddingModelService';
import useEmbeddingModels from '../../../../Hooks/useEmbeddingModels';
import { RootState, useAppSelector } from '../../../../store';
import { UserSettings } from '../../../../Types';
import PaginatedView from '../../../Utility/PaginatedView';

function ChatModels() {
    const settings = useAppSelector((state: RootState) => state.settings);
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const { ModelsActions, handleCopyModel, handleNavigate, i18n, windowWidth, getBreakpoint } = useEmbeddingModels();
    const GRID_COLS = 'grid-cols-[1fr_auto]'; 

    return (
        <>
            <PaginatedView
                listType={PaginationListType.EmbeddingModels}
                itemsFunction={embeddingModelService.getModelsByPage}
                itemsPerPage={15}
                renderItem={(model: EmbeddingModel, index: number) => (
                    <AdminViewContent
                        key={model.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={model.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: model.title,
                                    image: model.image,
                                    showImage: true,
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        variant: 'primaryRound',
                                        onClick: () => handleNavigate(`/admin/embeddingmodels/${model.identifier}`),
                                        icon: <PencilSimpleIcon />,
                                    },
                                    {
                                        variant: 'secondaryRound',
                                        onClick: () => handleCopyModel(model),
                                        icon: <CopyIcon />,
                                    },
                                    {
                                        variant:
                                            model.identifier === settings.embeddingModel
                                                ? 'disabledRound'
                                                : 'secondaryRound',
                                        onClick: () =>
                                            model.identifier === settings.embeddingModel
                                                ? null
                                                : ModelsActions.handleOpenConfirmDialog(model.identifier),
                                        icon: <TrashIcon />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            >
                {({ list, filter }) => (
                    <>
                        {filter}
                        <div className="mb-4 md:hidden">
                            {(!settings.demo || userSettings.isSuperAdmin) && (
                                <Button
                                    className="w-full mb-2"
                                    onClick={() => handleNavigate('/admin/embeddingmodels/new')}
                                >
                                    {i18n.translate({ id: 'button', sourceName: 'EmbeddingModels' })}
                                </Button>
                            )}
                        </div>
                        <div className="hidden md:block">
                            <div className={`grid ${GRID_COLS} gap-4 w-full px-4`}>
                                <div className="text-lg flex items-center">
                                    <strong>{i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' })}</strong>
                                </div>
                                {(!settings.demo || userSettings.isSuperAdmin) && (
                                    <div className="flex justify-end gap-2">
                                        <Button
                                            variant="primary"
                                            className="h-[51px]"
                                            onClick={() => handleNavigate('/admin/embeddingmodels/new')}
                                        >
                                            {i18n.translate({ id: 'button', sourceName: 'EmbeddingModels' })}
                                        </Button>
                                    </div>
                                )}
                            </div>
                            <hr className="border-layout-borderColor mt-5" />
                        </div>
                        {list}
                    </>
                )}
            </PaginatedView>
        </>
    );
}

export default ChatModels;
